<template lang="pug">
.container-restrictions(id="PlayListItemPlayProperties-container")
  .row
    .header
      p {{$t('Duration:')}}
    el-radio-group(v-model='durationStrategy', size="mini")
      el-radio-button(id="PlayListItemPlayProperties-durationNaturalButton" label='Natural')
        span {{ $t('Natural') }} &nbsp;
        font-awesome-icon(icon="clock")
      el-radio-button(id="PlayListItemPlayProperties-durationForcedButton" label='Forced')
        span {{ $t('Forced') }} &nbsp;
        font-awesome-icon(icon="ruler-horizontal")
    span &nbsp; ({{ msToDuration(naturalDurationMs) }} {{$t('natural duration')}})
  .row
    .header &nbsp;
    DurationInput(
      id="PlayListItemPlayProperties-durationInput",
      :disabled='!(durationStrategy === "Forced")',
      :durationMs='playParams.playDurationMs',
      @durationUpdated='updatePlayItemDuration'
    )
  .row
    .header
      p {{$t('After end:')}}
      p {{$t('(if forced duration is longer than natural)')}}
    el-radio-group(
      v-model='playParams.onEndBehaviour',
      :disabled='!(playParams.playDurationMs > naturalDurationMs)',
      size="mini"
    )
      el-radio-button(label='loop' id="PlayListItemPlayProperties-onEndLoopButton" )
        span {{ $t('Loop') }} &nbsp;
        font-awesome-icon(icon="recycle")
      el-radio-button(label='transparent' id="PlayListItemPlayProperties-onEndStopButton" )
        span {{ $t('Stop') }} &nbsp;
        font-awesome-icon(icon="hand-paper")
    span(v-if='playParams.onEndBehaviour === "transparent"') &nbsp; ({{ msToDuration(playParams.playDurationMs - naturalDurationMs) }}
      span(v-if="playListItem.Medium.type === 'Audio'") {{$t(' of silence') }}
      span(v-if="playListItem.Medium.type !== 'Audio'") {{$t(' of transparency') }}
      span )
    span(v-if='playParams.onEndBehaviour === "loop"') &nbsp; ({{$t('loop')}} {{ parseFloat(playParams.playDurationMs / naturalDurationMs).toFixed(3) }} {{$t(' times') }})
  .row(v-if="playList && playList.type.indexOf('Layout') > -1 && playListItem.Medium.type !== 'Audio'")
    .header {{$t('Other layout content:')}}
    el-radio-group(v-model='playParams.pausePlayOtherContent', size="mini")
      el-radio-button(id="PlayListItemPlayProperties-otherContentPlayButton" label="play")
        span {{ $t('Play') }} &nbsp;
        font-awesome-icon(icon="play")
      el-radio-button(id="PlayListItemPlayProperties-otherContentPauseButton" label="pause")
        span {{ $t('Pause') }} &nbsp;
        font-awesome-icon(icon="pause")
  .row
    .header
      p {{$t('Offset ms:')}}
    .input
      el-input-number(id="PlayListItemPlayProperties-offsetInput" size="mini", v-model="playParams.playOffsetMs", clearable, type="number")
  .row(v-if="playListItem.Medium.type !== 'Audio'")
    .header
      p {{$t('Content fit strategy:')}}
    .input
      el-radio-group(v-model='playParams.objectFit', size="mini")
        el-radio-button(id="PlayListItemPlayProperties-fitDefaultButton" label="default")
          span {{ $t('Default') }}
        el-radio-button(id="PlayListItemPlayProperties-fitFillButton" label="fill")
          span {{ $t('Fill') }}
    .input
      el-radio-group(v-model='playParams.objectFit', size="mini")
        el-radio-button(id="PlayListItemPlayProperties-fitContainButton" label="contain")
          span {{ $t('Contain') }}
        el-radio-button(id="PlayListItemPlayProperties-fitCoverButton" label="cover")
          span {{ $t('Cover') }}
        el-radio-button(id="PlayListItemPlayProperties-fit1to1Button" label="none")
          span {{ $t('1:1') }}
  .row
    .header
      p {{$t('Content position:')}}
      p {{$t('(for "Cover" and "1:1" strategies)')}}
    .input
      p {{$t('horizontal:')}}
      el-radio-group(v-model='objectPositionHorizontal', size="mini", :disabled='!needsPositioning')
        el-radio-button(id="PlayListItemPlayProperties-objectPositionHorizontalLeftButton" label="left")
          span {{ $t('left') }}
        el-radio-button(id="PlayListItemPlayProperties-objectPositionHorizontalCenterButton" label="center")
          span {{ $t('center') }}
        el-radio-button(id="PlayListItemPlayProperties-objectPositionHorizontalRightButton" label="right")
          span {{ $t('right') }}
    .input
      p {{$t('vertical:')}}
      el-radio-group(v-model='objectPositionVertical', size="mini", :disabled='!needsPositioning')
        el-radio-button(id="PlayListItemPlayProperties-objectPositionVerticalTopButton" label="top")
          span {{ $t('top') }}
        el-radio-button(id="PlayListItemPlayProperties-objectPositionVerticalCenterButton" label="center")
          span {{ $t('center') }}
        el-radio-button(id="PlayListItemPlayProperties-objectPositionVerticalBottomButton" label="bottom")
          span {{ $t('bottom') }}
  .row(v-if="playListItem.Medium.type !== 'Audio'")
    .header
      p {{$t('Rotation:')}}
    .input
      el-input-number(id="PlayListItemProperties-rotationInput" v-model="playParams.objectRotation", size="mini", clearable, type="number")
  .row.button
    el-button(
      id="PlayListItemProperties-submitButton",
      type="success",
      size="mini",
      @click="savePlayParams()",
      native-type="submit",
      :disabled='isSaving'
    )
      font-awesome-icon(icon="save")
      span &nbsp; {{ !isSaving ? $t('Set display properties') : $t('saving...')}}
</template>

<script>
import Vue from 'vue'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'
import DurationInput from '../Common/DurationInput'

export default {
  components: {
    DurationInput
  },
  props: ['playListItem', 'playList'],
  mixins: [mediaUtils, textUtils],
  watch: {
    objectPositionHorizontal: async function (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.playParams.objectPosition = this.objectPositionHorizontal + ' ' + this.objectPositionVertical
      }
    },
    objectPositionVertical: async function (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.playParams.objectPosition = this.objectPositionHorizontal + ' ' + this.objectPositionVertical
      }
    },
    durationStrategy: async function (newVal, oldVal) {
      if (oldVal !== newVal && newVal === 'Natural') {
        this.playParams.playDurationMs = 0
      }
    }
  },
  mounted () {
    if (
      this.playParams.playDurationMs !== this.naturalDurationMs ||
      this.playListItem.playDurationMs > 0
    ) {
      this.durationStrategy = 'Forced'
    }
  },
  data () {
    return {
      isSaving: false,
      durationStrategy: 'Natural',
      playParams: {
        playDurationMs: this.durationCalculated(),
        playOffsetMs: this.playListItem.playOffsetMs,
        objectFit: this.playListItem.objectFit,
        objectPosition: this.playListItem.objectPosition,
        onEndBehaviour: this.playListItem.onEndBehaviour,
        pausePlayOtherContent: this.playListItem.pausePlayOtherContent,
        objectRotation: this.playListItem.objectRotation
      },
      objectPositionHorizontal: this.playListItem.objectPosition.split(' ')[0],
      objectPositionVertical: this.playListItem.objectPosition.split(' ')[1]
    }
  },
  methods: {
    updatePlayItemDuration (data) {
      this.playParams.playDurationMs = data
    },
    buttonSaveText () {
      if (this.isSaving) return 'saving data...'
      return 'Save play parameters'
    },
    __validateInput () {
      if (this.playListItem.playDurationMs < 0) return false
      return true
    },
    async savePlayParams () {
      if (!this.__validateInput()) return
      this.isSaving = true
      if (this.playParams.playDurationMs === '' || this.durationStrategy === 'Natural') {
        if (this.playListItem.Medium.type === 'Video') {
          this.playParams.playDurationMs = 0
        }
        if (
          this.playListItem.Medium.type === 'Image' ||
          this.playListItem.Medium.type === 'HTML5app' ||
          this.playListItem.Medium.type === 'HTMLzip'
        ) {
          this.playParams.playDurationMs = 0
        }
        if (this.playListItem.Medium.type.startsWith('PlayList')) {
          this.playParams.playDurationMs = 0
        }
      }
      if (this.playParams.playOffsetMs === '') {
        this.playParams.playOffsetMs = 0
      }
      if (this.playParams.objectRotation === '') {
        this.playParams.objectRotation = 0
      }
      const path = `PlayListItem/${this.playListItem.id}`
      await Vue.axios.patch(path, this.playParams)
      this.isSaving = false
      this.$emit('close')
    },
    durationCalculated () {
      if (this.playListItem.Medium.type === 'Video' || this.playListItem.Medium.type === 'Audio') {
        return this.playListItem.playDurationMs > 0
          ? this.playListItem.playDurationMs
          : this.playListItem.File.originalDurationMs
      }
      if (
        this.playListItem.Medium.type === 'Image' ||
        this.playListItem.Medium.type === 'HTML5app' ||
        this.playListItem.Medium.type === 'HTMLzip'
      ) {
        return this.playListItem.playDurationMs > 0
          ? this.playListItem.playDurationMs
          : 5000
      }
      if (this.playListItem.Medium.type.startsWith('PlayList')) {
        return this.playListItem.playDurationMs > 0
          ? this.playListItem.playDurationMs
          : this.playListItem.Medium.playListDurationMs
      }
    }
  },
  computed: {
    playParamsPlayDurationMsChanged () {
      return (
        this.playParams.playDurationMs !== this.playListItem.playDurationMs
      )
    },
    naturalDurationMs () {
      if (this.playListItem.Medium.type.startsWith('Image')) return 5000
      return this.playListItem.Medium.type.startsWith('PlayList') ? this.playListItem.Medium.playListDurationMs : this.playListItem.File.originalDurationMs
    },
    needsPositioning () {
      return (this.playParams.objectFit === 'none' || this.playParams.objectFit === 'cover') && this.playListItem.Medium.type !== 'Audio'
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-restrictions {
  font-size: $--font-size-base;
  margin: auto;
  width: 100%;
  .row {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    .header {
      font-size: $--font-size-big;
      font-weight: bold;
      width: 300px;
    }
    .human-duration {
      text-align: right;
      font-size: $--font-size-mini;
      color: $--color-text-placeholder;
    }
    .naturalDuration {
      background-color: rgba(#000, 0);
      border: 0px;
    }
    &.button {
      // width: 100%;
      justify-content: flex-end;
    }
  }
  .icon {
    color: $--color-text-regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/PlayListItemPlayProperties.vue